import React, { useState } from 'react';
import { formatPrice } from '../../utils/utils';
import '../../styles/promo-codes.css';

export default function PromoCodeInput({ promo, disabled = false, needsRefresh = false, onRefresh }) {
  const [expanded, setExpanded] = useState(false);
  const remove = () => { promo.remove(); setExpanded(false); };
  const applied = Boolean(promo.quote);
  const valid = Boolean(promo.quote) && !needsRefresh;
  const status = promo.busy ? 'Перевіряємо промокод…' : needsRefresh ? 'Оновіть розрахунок' : valid ? 'Промокод застосовано' : 'Промокод';

  return <div className='promo-code-input'>
    {!expanded && !applied && !promo.appliedCode && !promo.error ? <button type='button' className='btn promo-code-toggle p-0' disabled={disabled}
      aria-expanded={false} aria-controls='checkout-promo-fields' onClick={() => setExpanded(true)}>
      <i className='bi bi-ticket-perforated mr-2' aria-hidden='true' />Ввести промокод
    </button> : <div id='checkout-promo-fields'>
      {applied ? <div className={`checkout-promo-applied${valid ? ' checkout-promo-applied--valid' : ''}`}>
        <i className={`bi ${valid ? 'bi-check-circle-fill' : 'bi-ticket-perforated'}`} aria-hidden='true' />
        <div className='checkout-promo-applied-content'>
          <span className='checkout-promo-applied-status' role='status'>{status}</span>
          <span className='checkout-promo-applied-code' title={promo.text}>{promo.text}</span>
        </div>
        {(promo.error || needsRefresh) && <button type='button' className='checkout-promo-icon-button' aria-label='Оновити розрахунок' title='Оновити розрахунок'
          disabled={disabled || promo.busy} onClick={onRefresh || promo.apply}><i className='bi bi-arrow-clockwise' aria-hidden='true' /></button>}
        <button type='button' className='checkout-promo-icon-button' aria-label='Видалити промокод' title='Видалити промокод'
          disabled={disabled} onClick={remove}><i className='bi bi-x-lg' aria-hidden='true' /></button>
      </div> : <>
        <label htmlFor='checkout-promo-code' className='checkout-promo-label'>Промокод</label>
        <div className='checkout-promo-entry'>
          <div className='checkout-promo-field'>
            <input id='checkout-promo-code' className='form-control' value={promo.text}
              maxLength={64} autoComplete='off' autoCapitalize='none' spellCheck={false}
              placeholder='Введіть промокод' disabled={disabled || promo.busy} autoFocus
              aria-describedby={promo.error ? 'checkout-promo-error' : undefined} aria-invalid={Boolean(promo.error)}
              onChange={event => promo.setText(event.target.value)}
              onKeyDown={event => { if (event.key === 'Enter') { event.preventDefault(); if (!disabled && !promo.busy) promo.apply(); } }} />
            {promo.appliedCode && <button type='button' className='checkout-promo-icon-button' disabled={disabled || promo.busy}
              aria-label='Скасувати промокод' title='Скасувати промокод' onClick={remove}><i className='bi bi-x-lg' aria-hidden='true' /></button>}
          </div>
          <button type='button' className='btn btn-dark' disabled={disabled || promo.busy || !promo.text.trim()}
            aria-busy={promo.busy} onClick={promo.apply}>Застосувати</button>
        </div>
      </>}
      {promo.error && <div id='checkout-promo-error' className='promo-code-error text-danger mt-2' role='alert'>
        {promo.error}
        {applied && <div>Видаліть промокод або оновіть розрахунок, щоб продовжити.</div>}
      </div>}
      {promo.quote?.minOrderAmount != null && <div className='small text-muted mt-2'>
        Від {formatPrice(promo.quote.minOrderAmount)} грн відповідних товарів.
      </div>}
    </div>}
  </div>;
}
